import common from '../../common.js';

export default {
  async loadAllSites(context, payload ) 
  {
    const responseJson = await common.getRequest(context, payload, `system/sites/bytype/${payload}`)
       
    for (const key in responseJson) {
      for (const propKey in responseJson[key].containerProperties) {
        responseJson[key][propKey] = responseJson[key].containerProperties[propKey];
      }
      delete responseJson[key].containerProperties;
    }    
    console.log("ALL SITES", responseJson)
    context.commit('setSystemSites', responseJson)
 
  },

};
